// Сохранение состояния формы кампании в localStorage для разных сессий

import type { ICampaignWizardForm } from "../../../../../../../../../shared/types/form.type";

// Ключ записи в localStorage для сессии
const getFormStateKey = (sessionId: string) => `ba-form-state-${sessionId}`;

// Проверка, что из localStorage прочитан валидный объект формы
const isCampaignWizardForm = (value: unknown): value is ICampaignWizardForm => {
	if (!value || typeof value !== "object") return false;
	const record = value as Record<string, unknown>;
	return (
		typeof record.campaign_context === "object" &&
		record.campaign_context != null &&
		typeof record.campaign_form_raw === "object" &&
		record.campaign_form_raw != null
	);
};

// Есть ли сохранённый черновик для сессии
export const hasFormState = (sessionId: string): boolean => {
	return localStorage.getItem(getFormStateKey(sessionId)) != null;
};

// Читает черновик формы из localStorage
export const getFormState = (sessionId: string): ICampaignWizardForm | null => {
	try {
		const raw = localStorage.getItem(getFormStateKey(sessionId));
		if (!raw) return null;
		const parsed: unknown = JSON.parse(raw);
		if (!isCampaignWizardForm(parsed)) return null;
		return parsed;
	} catch {
		return null;
	}
};

// Записывает черновик формы в localStorage
export const setFormState = (
	sessionId: string,
	formState: ICampaignWizardForm,
) => {
	localStorage.setItem(getFormStateKey(sessionId), JSON.stringify(formState));
};

// Удаляет черновик формы для сессии
export const removeFormState = (sessionId: string) => {
	localStorage.removeItem(getFormStateKey(sessionId));
};

// Записывает начальный черновик для новой сессии, если его ещё нет
export const bootstrapFormStateForSession = (
	sessionId: string,
	formState: ICampaignWizardForm,
): void => {
	if (hasFormState(sessionId)) return;
	setFormState(sessionId, formState);
};
